import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTutoresModel } from '../../../../modelos/Tutores/modeloTutores';

const CotizarPorTutor = ({ solicitud, addNewCotizacion }) => {
  const [showModal, setShowModal] = useState(false);
  const [tutorSeleccionado, setTutorSeleccionado] = useState(null);
  const [precio, setPrecio] = useState('');
  const [comentario, setComentario] = useState('');
  const [loading, setLoading] = useState(false);

  // Obtenemos los tutores desde el modelo
  const { tutoresOptions , cargarTutores } = useTutoresModel();

  //cargar tutores
  useEffect(() => {
    cargarTutores();
  }, []);

  const abrirModal = () => setShowModal(true);
  
  const cerrarModal = () => {
    setShowModal(false);
    setTutorSeleccionado(null);
    setPrecio('');
    setComentario('');
  };

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape') {
        cerrarModal();
      }
    };

    if (showModal) {
      window.addEventListener('keydown', handleEsc);
    }

    // Limpieza del evento cuando el componente se desmonte o el modal se cierre
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [showModal, cerrarModal]);

  const handleGuardar = async () => {
    if (!tutorSeleccionado || !precio) {
      alert('Por favor completa los campos obligatorios');
      return;
    }

    setLoading(true);
    try {
      await addNewCotizacion(
        solicitud.nombreEmpresa,
        precio,
        comentario,
        solicitud.id,
        tutorSeleccionado.value
      );
      cerrarModal();
    } catch (error) {
      console.error('Error al crear cotización:', error);
      alert('Error al crear la cotización');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Botón disparador */}
      <button 
        onClick={abrirModal}
        className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-700 flex items-center transition-colors"
      >
        <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Cotizar por Tutor
      </button>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={cerrarModal}></div>
          
          <div className="relative bg-white rounded-lg shadow-xl w-full max-w-lg overflow-hidden">
            <div className="px-6 py-5">
              <h3 className="text-lg font-medium text-gray-900 mb-4">Cotizar por Tutor</h3>
              
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Tutor *</label>
                  <Select
                    value={tutorSeleccionado}
                    onChange={setTutorSeleccionado}
                    options={tutoresOptions}
                    placeholder="Seleccionar tutor..."
                    isSearchable
                    className="text-sm"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Precio *</label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
                    <input
                      type="number"
                      value={precio}
                      onChange={(e) => setPrecio(e.target.value)}
                      className="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500"
                      placeholder="0"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Comentario</label>
                  <textarea
                    value={comentario}
                    onChange={(e) => setComentario(e.target.value)}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500"
                    placeholder="Opcional..."
                  />
                </div>
              </div>
            </div>
            
            <div className="bg-gray-50 px-6 py-3 flex flex-row-reverse gap-2">
              <button
                onClick={handleGuardar}
                disabled={loading || !tutorSeleccionado || !precio}
                className="bg-blue-600 text-white px-4 py-2 rounded text-sm font-medium disabled:opacity-50"
              >
                {loading ? 'Creando...' : 'Crear Cotización'}
              </button>
              <button
                onClick={cerrarModal}
                className="bg-white border border-gray-300 px-4 py-2 rounded text-sm font-medium text-gray-700"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CotizarPorTutor;